/**
 * @file   src\components\Common\RadioButton.js
 * @brief  This file is responsible for radio button component
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";

const RadioButton = (props) => {
  return (
    <input
      className={props.className}
      id={props.id}
      name={props.name}
      type="radio"
      value={props.value}
      checked={props.checked}
      onChange={props.onChange}
      onClick={props.onClick}
      disabled={props.disabled}
    />
  );
};
export default RadioButton;
